// Campaign mode mission files. Each mission is a story plus the shirt it
// belongs to. `productSlug` points at a product in the API; until that
// product exists, the mission page shows its gear as inbound.
//
// The briefing copy below is a starting draft — replace it with the real
// story for each design. Add an `image` path (e.g. "/aegis/mission-001.jpg")
// once the artwork is ready.

export const MISSIONS = [
  {
    code: "001",
    slug: "dumpster-fire",
    name: "Dumpster Fire",
    status: "active",
    accent: "#E8692E",
    glow: "sticker-glow-fire",
    tagline: "When everything is burning, someone has to respond.",
    image: null,
    productSlug: "dumpster-fire-tee",
    briefing: [
      "Every shift has the call nobody wants. The situation that was already on fire before you walked in the door. The one with no good options and no time to find better ones.",
      "The Dumpster Fire Response Team is the crew that walks toward it anyway. Calm under pressure. Dark humor intact. The job gets handled, the fire gets put out, and everybody goes home.",
    ],
    objectives: [
      "Respond to the chaos",
      "Keep your head when others lose theirs",
      "Put the fire out. Go home.",
    ],
  },
  {
    code: "002",
    slug: "mule",
    name: "Mule",
    status: "active",
    accent: "#B08B4F",
    glow: "sticker-glow-gold",
    tagline: "Carry the load. Don't complain. Don't quit.",
    image: null,
    productSlug: "mule-tee",
    briefing: [
      "Some people get the spotlight. Others get the weight. The Mule is the one who shoulders it — the extra shift, the hard post, the job nobody else wanted.",
      "Stubborn. Steady. Built to keep moving when the ground gets rough. This one is for everyone who carries more than their share and never asks for credit.",
    ],
    objectives: [
      "Carry the weight",
      "Hold steady on rough ground",
      "Finish the march",
    ],
  },
  {
    code: "003",
    slug: "classified",
    name: "Classified",
    status: "classified",
    accent: "#8C92A0",
    tagline: "Coming soon. File access restricted.",
    image: null,
    productSlug: null,
    briefing: [],
    objectives: [],
  },
];

export const isMissionLocked = (mission) => mission.status !== "active";

export const getMission = (slug) => MISSIONS.find((m) => m.slug === slug);
